import { currentBridgeData } from '@databases/database-state/state/bridge-data';
import { selectDatabaseByContentIdOptional } from '@databases/utils/redux/databases/selectors';
import { isEqual } from 'lodash-es';

import { getDatabaseWithCurrentView } from '../../database-view';
import { type AppRootState } from '../../types';

export const hasRelevantStateChanged = (
  currentState: AppRootState,
  previousState: AppRootState
): boolean => {
  // check cell selections first (most likely to change, less expensive)
  if (
    !isEqual(
      currentState.cellSelections.selectedEntireFields,
      previousState.cellSelections.selectedEntireFields
    )
  ) {
    return true;
  }

  if (
    !isEqual(
      currentState.cellSelections.selectedEntireEntries,
      previousState.cellSelections.selectedEntireEntries
    )
  ) {
    return true;
  }
  if (
    !isEqual(
      currentState.cellSelections.selectedValues,
      previousState.cellSelections.selectedValues
    )
  ) {
    return true;
  }

  const contentId = currentBridgeData.data.contentId;

  if (
    !selectDatabaseByContentIdOptional(currentState, { contentId }) ||
    !selectDatabaseByContentIdOptional(previousState, { contentId })
  ) {
    return false;
  }

  const currentDatabase = getDatabaseWithCurrentView(currentState, { contentId });
  const previousDatabase = getDatabaseWithCurrentView(previousState, {
    contentId,
  });

  if (!isEqual(currentDatabase.fields, previousDatabase.fields)) {
    return true;
  }
  if (!isEqual(currentDatabase.entries, previousDatabase.entries)) {
    return true;
  }

  return false;
};
